import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className='about-us'>
      <div className='about-container'>
        <div className='about-section'>
          <div className='section-content'>
            <h2>Unlocking Global Opportunities</h2>
            <p>
              Destnation Education helps students migrate for higher education, ensuring
              professionalism and transparency through a well-curated system that provides reliable
              guidance for a smooth and trustworthy migration process.
            </p>
            <p>
              Embark on a transformative journey with DestNation Education, guiding students through
              international education, unlocking global opportunities, and ensuring access to top
              institutions with expert support throughout the process.
            </p>
          </div>
          <div className='section-image'>
            <img src='/assets/img/about/about-1.jpg' alt='Global Education' />
          </div>
        </div>

        <div className='services-section'>
          <div className='service-card'>
            <div className='service-icon'>
              <i className='fas fa-graduation-cap'></i>
            </div>
            <h3>Expert Consultation</h3>
            <p>
              Receive professional guidance for a seamless international education journey, ensuring
              informed decisions and access to top institutions worldwide.
            </p>
          </div>
          <div className='service-card'>
            <div className='service-icon'>
              <i className='fas fa-handshake'></i>
            </div>
            <h3>Trusted Advisory</h3>
            <p>
              Trusted Advisory offers expert guidance and personalized support to ensure successful
              medical education abroad experiences.
            </p>
          </div>
        </div>

        <div className='about-section reverse'>
          <div className='section-image'>
            <img src='/assets/img/about/about-2.jpg' alt='Free Counseling' />
          </div>
          <div className='section-content'>
            <h2>Free Online Counseling</h2>
            <p className='help-text'>We are ready to help you</p>
            <p>
              DestNation Education is a Dubai-based company that assists students in securing
              admissions to top universities, with a special focus on medical education.
            </p>
          </div>
        </div>

        <div className='philosophy-section'>
          <div className='philosophy-content'>
            <h2>Philosophy</h2>
            <p>
              At DestNation Education Consulting, we firmly believe in the transformative power of
              migration as a catalyst for cultural exchange and creating a harmonious blend that
              enriches the fabric of our global community. Migration is not merely a physical
              relocation but a dynamic process that transcends borders, fostering the convergence of
              diverse cultures, ideas, and perspectives.
            </p>
          </div>
          <div className='philosophy-image'>
            <img src='/assets/img/about/about-3.jpg' alt='Philosophy' />
          </div>
          <div className='philosophy-content'>
            <p>
              By facilitating students' movement across borders, we contribute to developing an
              academically proficient, culturally adept, and globally aware generation. We envision
              a world where the exchange of knowledge and cultural nuances transcends geographical
              boundaries, creating an environment where unity is forged through diversity.
            </p>
          </div>
        </div>

        <div className='mission-section'>
          <h2>Our Mission</h2>
          <div className='mission-grid'>
            <div className='mission-card'>
              <div className='mission-icon'>
                <i className='fas fa-globe'></i>
              </div>
              <h3>Empowering Global Minds</h3>
              <p>
                DestNation Education Consulting empowers aspiring students with seamless migration
                services that transcend borders. Our mission is to facilitate a cultural exchange
                beyond academic pursuits, fostering an environment where students from diverse
                backgrounds come together to create a rich tapestry of global perspectives. Through
                transparent, personalized, and comprehensive migration assistance, we aim to guide
                students on a transformative journey towards academic excellence and cross-cultural
                understanding.
              </p>
            </div>
            <div className='mission-card'>
              <div className='mission-icon'>
                <i className='fas fa-users'></i>
              </div>
              <h3>Cultivating Unity Through Education</h3>
              <p>
                Our mission at DestNation is to cultivate unity through education by providing
                top-notch migration services that prioritize cultural exchange and collaboration. We
                are committed to offering a transparent and personalized approach, ensuring that
                every student's migration journey is academically enriching and contributes to
                creating a global community bound by shared knowledge and respect for diversity. We
                strive to be the bridge that connects students to opportunities beyond borders,
                fostering a world where education becomes a universal language of understanding.
              </p>
            </div>
            <div className='mission-card'>
              <div className='mission-icon'>
                <i className='fas fa-graduation-cap'></i>
              </div>
              <h3>Shaping Global Citizens</h3>
              <p>
                At DestNation Education Consulting, our mission is to shape global citizens through
                comprehensive migration services that emphasize the fusion of cultures. We aspire to
                guide students on a journey that transcends geographical boundaries, providing
                academic support and fostering an appreciation for diverse perspectives. Our
                commitment to transparency and personalized counselling aims to create a community
                of students who, armed with a blend of knowledge and cultural insights, contribute
                to building a more interconnected and harmonious world.
              </p>
            </div>
          </div>
        </div>

        <div className='values-section'>
          <h2>Our Guiding Principles for Success</h2>
          <p className='values-subtitle'>Core Values</p>
          <div className='values-grid'>
            <div className='value-card'>
              <i className='fas fa-heart'></i>
              <h3>Integrity</h3>
              <p>
                We uphold the highest standards of integrity in all our interactions, ensuring
                transparency, honesty, and ethical conduct.
              </p>
            </div>
            <div className='value-card'>
              <i className='fas fa-user-friends'></i>
              <h3>Student-Centric Approach</h3>
              <p>
                We prioritize each student's unique needs and aspirations, delivering personalized
                guidance beyond the standard migration process.
              </p>
            </div>
            <div className='value-card'>
              <i className='fas fa-globe-americas'></i>
              <h3>Cultural Sensitivity</h3>
              <p>
                We celebrate and respect cultural diversity, recognizing it as a vital asset in our
                interconnected world.
              </p>
            </div>
            <div className='value-card'>
              <i className='fas fa-star'></i>
              <h3>Excellence in Service</h3>
              <p>
                We strive for excellence in every aspect of our service, from admissions to
                post-graduation support.
              </p>
            </div>
            <div className='value-card'>
              <i className='fas fa-lightbulb'></i>
              <h3>Innovation</h3>
              <p>
                We embrace innovation and adaptability as core principles in a rapidly evolving
                world.
              </p>
            </div>
            <div className='value-card'>
              <i className='fas fa-handshake'></i>
              <h3>Collaboration</h3>
              <p>
                We cultivate a collaborative environment built on teamwork, open communication, and
                a broad global outlook.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
